module.exports = __webpack_public_path__ + "img/04.b7a14ad4.png";